var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDocuments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2083 23.0001C13.2083 22.6549 13.4882 22.3751 13.8333 22.3751H19.6667C20.0118 22.3751 20.2917 22.6549 20.2917 23.0001C20.2917 23.3453 20.0118 23.6251 19.6667 23.6251H13.8333C13.4882 23.6251 13.2083 23.3453 13.2083 23.0001Z",
    fill: "#656579"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2083 19.6667C13.2083 19.3216 13.4882 19.0417 13.8333 19.0417H14.6667C15.0118 19.0417 15.2917 19.3216 15.2917 19.6667C15.2917 20.0119 15.0118 20.2917 14.6667 20.2917H13.8333C13.4882 20.2917 13.2083 20.0119 13.2083 19.6667Z",
    fill: "#656579"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2083 16.3334C13.2083 15.9882 13.4882 15.7084 13.8333 15.7084H16.3333C16.6785 15.7084 16.9583 15.9882 16.9583 16.3334C16.9583 16.6786 16.6785 16.9584 16.3333 16.9584H13.8333C13.4882 16.9584 13.2083 16.6786 13.2083 16.3334Z",
    fill: "#656579"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2083 9.66675C13.2083 9.32157 13.4882 9.04175 13.8333 9.04175H21.75C21.9158 9.04175 22.0747 9.1076 22.1919 9.22481L25.9419 12.9748C26.0592 13.092 26.125 13.251 26.125 13.4167V23.8334C26.125 24.1786 25.8452 24.4584 25.5 24.4584C25.1548 24.4584 24.875 24.1786 24.875 23.8334V13.6756L21.4911 10.2917H13.8333C13.4882 10.2917 13.2083 10.0119 13.2083 9.66675Z",
    fill: "#656579"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.75 12.7917C11.4048 12.7917 11.125 13.0716 11.125 13.4167V25.0834C11.125 25.4286 11.4048 25.7084 11.75 25.7084H21.75C22.0952 25.7084 22.375 25.4286 22.375 25.0834V15.3423L19.8244 12.7917H11.75ZM9.875 13.4167C9.875 12.3812 10.7145 11.5417 11.75 11.5417H19.8762C20.1746 11.5417 20.4607 11.6603 20.6717 11.8713L23.2955 14.495C23.5065 14.706 23.625 14.9922 23.625 15.2905V25.0834C23.625 26.1189 22.7855 26.9584 21.75 26.9584H11.75C10.7145 26.9584 9.875 26.1189 9.875 25.0834V13.4167Z",
    fill: "#656579"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6667 11.5417C20.0118 11.5417 20.2917 11.8216 20.2917 12.1667V14.8751H23C23.3452 14.8751 23.625 15.1549 23.625 15.5001C23.625 15.8453 23.3452 16.1251 23 16.1251H20.1667C19.5453 16.1251 19.0417 15.6214 19.0417 15.0001V12.1667C19.0417 11.8216 19.3215 11.5417 19.6667 11.5417Z",
    fill: "#656579"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDocuments);
export default __webpack_public_path__ + "static/media/iconDocuments.60414fb650514b64d3c1466b19dc7635.svg";
export { ForwardRef as ReactComponent };